module.exports = __webpack_public_path__ + "img/c_photo_4@2x.19653e48.png";